<template>
  <section class="comment">
    <!--作者信息开始-->
    <dl class="map-info-box">
      <dt class="title clearfix">
        <span class="left">
          <img class="image" src="./img/head-default.png" alt="头像"/>
        </span>

        <span class="right">
          <span class="item">{{ mapInfo.MapName }}</span>
          <span class="item">作者昵称：{{ mapInfo.Developer }}</span>
        </span>
      </dt>

      <dd class="info">
        <span class="item">地图ID：{{ mapInfo.MapId }}</span>
        <span class="item">作者ID：{{ mapInfo.DeveloperId }}</span>
      </dd>

      <dd class="time">
        <span class="item"></span>
        <span class="item">创建日期：{{ mapInfo.CreateTime }}</span>
      </dd>
    </dl>
    <!--作者信息结束-->

    <!--评论信息开始-->
    <dl class="comment-info-box">
      <dt class="comment-info">
        <i class="icon-comment"></i>
        <span class="item">评论</span>
        <span class="item">留言数：{{ mapInfo.ReviewNum }}</span>
      </dt>

      <dd class="leaving-count">
        <span>点赞数：{{ mapInfo.AdmireNum }}</span>
      </dd>

      <dd class="leaving-btn-box">
        <a class="btn" href="javascript: void(0)" @click="addLeavingFn">
          <span class="text">发布评论</span>
          <!--<i class="icon-leaving"></i>-->
        </a>
      </dd>
    </dl>
    <!--评论信息结束-->

    <!--评论列表开始-->
    <ul class="leaving-list">
      <li class="list-item clearfix" v-for="item in commentInfo">
        <div class="left">
          <img class="image" src="./img/head-default.png" alt="头像"/>
        </div>

        <div class="right">
          <div class="top">
            <span>{{ item.NickName }}</span>
            <span class="time">{{ item.CreateTimeStr }}</span>
            <a class="fabulous-btn" href="javascript: void(0)">
              <i :class="{ 'icon-fabulous-blue' : item.AdmireNum === 1 }"></i>
            </a>
          </div>

          <p class="bottom">{{ item.Content }}</p>
        </div>
      </li>
    </ul>
    <!--评论列表结束-->

    <!--更多-->
    <p class="load-more more" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">{{ loadMoreText }} </p>

    <!--添加留言弹出层开始-->
    <div class="add-leaving-box"  v-show="leavingFlag">
      <h3 class="title">
        <a class="go-back" href="javascript: void(0)" @click="colseLeavingFn">
          <i class="icon-go-back"></i>
        </a>

        <span class="text">添加评论</span>

        <a class="release" href="javascript: void(0)" @click="subCommentFn">发布</a>
      </h3>

      <div class="content">
        <p class="desc">
          是否为游戏点赞：
          <i onselectstart="return false" :class="admireFlag ? 'icon-fabulous-blue' : 'icon-fabulous-yellow'" @click="admireFlag = !admireFlag"></i>
        </p>

        <textarea class="leaving-content" placeholder="请写下您的宝贵意见" ref="leavingText" v-model="formDatas.leavingContent" maxlength="100"></textarea>
      </div>
    </div>
    <!--添加留言弹出层结束-->

    <!--加载提示层-->
    <v-loading :show="loading"></v-loading>

    <!--提示层-->
    <v-basic-mask :show="tipsShow" @closeMaskEv="closeMaskEvFn">
      <span slot="desc">{{ tipsText }}</span>
    </v-basic-mask>
  </section>
</template>

<script type="text/ecmascript-6">
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // lading 加载组件
  import loading from 'components/loading/loading'
  // 基础弹出层组件
  import basicMask from 'components/basicMask/basicMask'
  // 分页长度
  const PAGE_SIZE = 10
  // 禁用词
  // const DISABLE_WORDS = ['哈哈', '呵呵']
  // 错误提示
  const ERROR_TIPS = [
    { desc: '网络错误' },
    { desc: '评论内容不能为空且不能少于少于五个字' },
    { desc: '有敏感词' },
    { desc: '未知错误' }
  ]
  export default {
    name: 'comment',
    data () {
      return {
        // 屏蔽字标记
        // disableFlag: false,
        // 提示层开关
        tipsShow: false,
        // 提示信息
        tipsText: '',
        // 留言弹出层标志
        leavingFlag: false,
        // 禁止滚动加载数据
        busy: true,
        // 是否显示 loading 加载
        loading: false,
        // 评论信息
        commentInfo: '',
        // 地图信息
        mapInfo: '',
        // 分页提示信息
        loadMoreText: '向上滑动查看更多 ',
        // 点赞或评论标记 0 评论 1 点赞
        admireFlag: false,
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID'),
          // 用户 id
          accountId: this.$route.params.accountId,
          // 地图 id
          mapId: this.$route.params.mapId,
          // xxxid
          passKey: this.$route.params.passKey,
          // 评论内容
          leavingContent: '',
          // 当前分页
          page: 1,
          // 分页长度
          pageSize: PAGE_SIZE
        }
      }
    },
    computed: {
      // 评论或点赞 0 评论 1 点赞
      admireVal () {
        if (this.admireFlag) {
          return 1
        } else {
          return 0
        }
      }
    },
    created () {
      // 页面加载初始化数据
      this.init()
    },
    mounted () {
      // axios 前置拦截器
      Axios.interceptors.request.use(config => {
        // 显示 loading 提示层
        this.loading = true
        return config
      })
      // axios 后置拦截器
      Axios.interceptors.response.use(response => {
        // 关闭 loading 提示层
        this.loading = false
        return response
      })
    },
    methods: {
      // 初始化
      init () {
        // 加载评论数据
        this.getCommentInfoFn()
        // 获取地图数据
        this.getMapInfoFn()
      },
      // 添加留言
      addLeavingFn () {
        // 打开留言弹出层
        this.leavingFlag = true
        // 弹出显示完毕后
        this.$nextTick(() => {
          // 获取留言输入框的焦点
          this.$refs.leavingText.focus()
        })
      },
      // 关闭浏览弹出层
      colseLeavingFn () {
        this.leavingFlag = false
      },
      // 获取地图相关信息
      getMapInfoFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('userId', this.formDatas.userId)
        // 将session id表单
        formData.append('sessionId', this.formDatas.sessionId)
        // 用户 id
        formData.append('AccountId', this.formDatas.accountId)
        // 地图 id
        formData.append('MapId', this.formDatas.mapId)
        // xxxid
        formData.append('PassKey', this.formDatas.passKey)
        // 当前分页
        formData.append('pageIndex', this.formDatas.page)
        // 分页长度
        formData.append('pageSize', this.formDatas.pageSize)
        // 获取地图信息 api
        Axios.post(`${this.$api.root}/MapReview/GetMapInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                this.mapInfo = res
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                // 返回登录页面
                this.$router.push({name: 'login'})
                break
              case 2:
                // 获取错误信息
                this.tipsText = res.Msg
                // 提示层开关
                this.tipsShow = true
                break
              default:
                // 获取错误信息
                this.tipsText = ERROR_TIPS[0].desc
                // 提示层开关
                this.tipsShow = true
            }
          }
        }).catch((error) => {
          // 获取错误信息
          this.tipsText = ERROR_TIPS[0].desc
          // 提示层开关
          this.tipsShow = true
          console.log(error)
        })
      },
      // 获取评论信息
      getCommentInfoFn (flag) {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('userId', this.formDatas.userId)
        // 将session id表单
        formData.append('sessionId', this.formDatas.sessionId)
        // 用户 id
        formData.append('AccountId', this.formDatas.accountId)
        // 地图 id
        formData.append('MapId', this.formDatas.mapId)
        // xxxid
        formData.append('PassKey', this.formDatas.passKey)
        // 当前分页
        formData.append('pageIndex', this.formDatas.page)
        // 分页长度
        formData.append('pageSize', this.formDatas.pageSize)
        // 请求评论信息 api
        Axios.post(`${this.$api.root}/MapReview/GetReviewList`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // this.commentInfo = res.ItemList
                // 分页调用
                if (flag) {
                  if (res.ItemList !== null) {
                    // 分页数据累加
                    this.commentInfo = this.commentInfo.concat(res.ItemList)
                    // 如果没有数据了
                    if (res.ItemList.length === 0) {
                      // 禁止滚动加载数据
                      this.busy = true
                      // 修改提示信息
                      this.loadMoreText = '没有更多评论了'
                      // 如果有数据
                    } else {
                      // 开启滚动加载数据
                      this.busy = false
                    }
                  }
                // 其他调用
                } else {
                  // 将数据赋值到属性
                  this.commentInfo = res.ItemList
                  // 开启滚动加载数据
                  this.busy = false
                }
                break
              case 1:
                // 删除登录信息
                // delUserCookie()
                // this.$router.push({name: 'login'})
                break
              case 2:
                // 获取错误信息
                this.tipsText = res.Msg
                // 提示层开关
                this.tipsShow = true
                break
              default:
                // 获取错误信息
                this.tipsText = ERROR_TIPS[3].desc
                // 提示层开关
                this.tipsShow = true
            }
          }
        }).catch((error) => {
          // 获取错误信息
          this.tipsText = ERROR_TIPS[0].desc
          // 提示层开关
          this.tipsShow = true
          console.log(error)
        })
      },
      // 分页加载
      loadMore () {
        // 禁止滚动加载
        this.busy = true

        setTimeout(() => {
          // 分页自增
          this.formDatas.page++
          // 加载商品数据
          this.getCommentInfoFn(true)
        }, 500)
      },
      // 回复评论
      subCommentFn () {
        // 评论不能为空且不能少于五个字
        if (this.formDatas.leavingContent !== '' && this.formDatas.leavingContent.length >= 5) {
          /*
          for (let i = 0; i < DISABLE_WORDS.length; i++) {
            // 有过滤词汇
            if (this.formDatas.leavingContent.indexOf(DISABLE_WORDS[i]) >= 0) {
              // 有屏蔽的关键词
              this.disableFlag = true
              // 错误提示
              this.tipsText = ERROR_TIPS[2].desc
              // 提示层开关
              this.tipsShow = true
              break
            // 过滤词检测通过
            } else {
              // 取消屏蔽字标记
              this.disableFlag = false
            }
          }
          */
          // 实例化表单对象
          let formData = new FormData()
          // 将用户名添加到表单
          formData.append('userId', this.formDatas.userId)
          // 将session id表单
          formData.append('sessionId', this.formDatas.sessionId)
          // 用户 id
          formData.append('AccountId', this.formDatas.accountId)
          // 地图 id
          formData.append('MapId', this.formDatas.mapId)
          // xxxid
          formData.append('PassKey', this.formDatas.passKey)
          // 评论内容
          formData.append('Content', this.formDatas.leavingContent)
          // 评论或点赞 0 评论 1 点赞
          formData.append('ReviewType', 0)
          // 评论的同时是否点赞
          formData.append('AdmireNum', this.admireVal)
          // 评论 api
          Axios.post(`${this.$api.root}/MapReview/CreateReview`, formData, {
            // 设置请求为表单提交
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((response) => {
            // http 请求成功
            if (response.status === 200) {
              // 获取接口数据
              let res = response.data
              switch (res.Code) {
                case 0:
                  this.leavingFlag = false
                  // 清空留言
                  this.formDatas.leavingContent = ''
                  // 初始化分页
                  this.formDatas.page = 1
                  // 加载评论数据
                  this.init()
                  break
                case 1:
                  // 删除登录信息
                  delUserCookie()
                  this.$router.push({name: 'login'})
                  break
                case 2:
                  // 获取错误信息
                  this.tipsText = res.Msg
                  // 提示层开关
                  this.tipsShow = true
                  break
                default:
                  // 获取错误信息
                  this.tipsText = ERROR_TIPS[3].desc
                  // 提示层开关
                  this.tipsShow = true
              }
            }
          }).catch((error) => {
            // 获取错误信息
            this.tipsText = ERROR_TIPS[0].desc
            // 提示层开关
            this.tipsShow = true
            console.log(error)
          })
        } else {
          // 错误提示
          this.tipsText = ERROR_TIPS[1].desc
          // 提示层开关
          this.tipsShow = true
        }
      },
      // 关闭提示层
      closeMaskEvFn (val) {
        // 关闭弹出层
        this.tipsShow = val
      }
    },
    components: {
      'v-loading': loading,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "comment.styl";
</style>



// WEBPACK FOOTER //
// src/views/comment/comment.vue